import type { FormInitialValues } from '../typings';

// Module scope like sent values: a snapshot can land while a remove or clear holds them, from a
// Retry or a tab hide that reaches the queue past the inert form, and must still keep them.
const setAsideValues = new Map<string, FormInitialValues>();

const NOTHING_SET_ASIDE: Readonly<FormInitialValues> = {};

/** Records waiting values a remove or clear took out of one form's queue while it runs. */
export const setAside = (saveKey: string, values: FormInitialValues): void => {
  if (Object.keys(values).length === 0) return;
  setAsideValues.set(saveKey, { ...setAsideValues.get(saveKey), ...values });
};

/** Lets go of `fieldIds`, put back in the queue or dropped with the entries they named. */
export const releaseSetAside = (saveKey: string, fieldIds: readonly string[]): void => {
  const forKey = setAsideValues.get(saveKey);
  if (!forKey) return;
  const left = { ...forKey };
  fieldIds.forEach(fieldId => delete left[fieldId]);
  if (Object.keys(left).length === 0) setAsideValues.delete(saveKey);
  else setAsideValues.set(saveKey, left);
};

/** The values one form has set aside, by field id. */
export const getSetAsideValues = (saveKey: string): Readonly<FormInitialValues> =>
  setAsideValues.get(saveKey) ?? NOTHING_SET_ASIDE;

/** Lets go of every set-aside value of every form. */
export const clearSetAsideValues = (): void => {
  setAsideValues.clear();
};
